/** Faster than this, back to the size before last, nobody is resizing anything */
const FLIP_MS = 100;
const SAME_PX = 0.5;

type Size = { width: number; height: number };

const same = (a: Size, b: Size) =>
  Math.abs(a.width - b.width) <= SAME_PX &&
  Math.abs(a.height - b.height) <= SAME_PX;

/**
 * Konkord: a size that feeds the layout which decides that size can go back and
 * forth on every frame (a scrollbar appearing makes the tiles smaller, which
 * makes it go away, which makes them bigger...), and the call flickers. Says
 * whether a new size is worth using: not when it's the one before last, a moment
 * after the last change.
 */
export function createFlipGuard() {
  let last: Size | undefined;
  let before: Size | undefined;
  let changedAt = -Infinity;

  return (size: Size, now = performance.now()) => {
    if (last && same(size, last)) return false;
    if (before && same(size, before) && now - changedAt < FLIP_MS) return false;
    before = last;
    last = { width: size.width, height: size.height };
    changedAt = now;
    return true;
  };
}
